import styles from "./index.module.scss";
import WalletIcon from "../../icons/wallet";
import { useNavigate } from "react-router-dom";
import useSeasonId from "../../hooks/use-season-id";

const JoinSeason = () => {
  const navigate = useNavigate();
  const seasonId = useSeasonId();

  const handleClickJoinSeason = () => {
    if (!seasonId) {
      return;
    }
    navigate(`/season/${seasonId}`);
  };

  return (
    <div className={styles.button} onClick={handleClickJoinSeason}>
      <WalletIcon />
      奖学金
    </div>
  );
};

export default JoinSeason;
